interface Constructor {
  name: string;
}
export class TypedNull {
  ty: Constructor;
  constructor(ty: Constructor) {
    this.ty = ty;
  }
}
